import dayjs from "dayjs";

// Αν χρησιμοποιηθεί στο yup σε συνδυασμό με yup.date(), μπορεί να χτυπήσει αν του περάσεις
// απευθείας την τιμή, επειδή αλλάζει σε άλλο format από dayjs
export const validateEndDateIsBeforeStartDate = (startDate, endDate, startTime = null, endTime = null) => {
	if (!startDate || !endDate) return true
	if (!startDate?.isValid() || !endDate?.isValid()) return false
	/* Εάν η startDate είναι datetime, τότε θα συγκρίνουμε απευθείας αυτό
	 * Εάν η startDate είναι date και περνάει σαν ξεχωριστή παράμετρος ο χρόνος,
	 * τότε φτιάχνουμε ένα datetime object με τον συνδυασμό των 2 πεδίων/
	 * Αντίστοιχα για το endDate.
	*/
	const startDateTime = !startTime ? startDate : dayjs(startDate)
	.hour(startTime ? startTime.hour() : 0)
	.minute(startTime ? startTime.minute() : 0)
	.second(startTime ? startTime.second() : 0)
	const endDateTime = !endTime ? endDate : dayjs(endDate)
	.hour(endTime ? endTime.hour() : 23)
	.minute(endTime ? endTime.minute() : 59)
	.second(endTime ? endTime.second() : 59)
	return startDateTime.isSame(endDateTime) || startDateTime.isBefore(endDateTime)
}